import React, { useEffect } from 'react';
import Typography from 'new/elements/Typography';
import { Stack } from '@mui/material';
import { Button } from 'new/elements/Button';
import { AddRounded } from '@mui/icons-material';
import { Section } from 'new/components/settings/VendorBuilder/components/Section';
import { useVendorBuilder } from 'new/components/settings/VendorBuilder/VendorBuilderContext';
import { SourceIteration } from 'new/components/settings/VendorBuilder/Endpoints/SourceIteration';

interface SourceIterationsProps {
  endpointIndex: number;
}

export const SourceIterations = (props: SourceIterationsProps) => {
  const { endpointIndex } = props;
  const { vendor, onAddEndpoint, updateVendor } = useVendorBuilder();

  const iterations = vendor.endpoints[endpointIndex]?.source_template?.['rest.iterations'] || [];

  useEffect(() => {
    updateVendor((newVendor) => {
      newVendor.endpoints[endpointIndex].source_template = {
        'rest.iterations': [
          {
            key: 'step1',
            method: '',
            'url.template': '',
            'response.data.path': '',
            isPaginated: false,
            'iteration.type': '',
          },
        ],
        'start.cron': '${start.cron}',
      };
    });

    return () => {
      updateVendor((newVendor) => {
        delete newVendor.endpoints[endpointIndex]?.source_template;
      });
    };
  }, []);

  const onAddIteration = () => {
    updateVendor((newVendor) => {
      const restIterations = newVendor.endpoints[endpointIndex]?.source_template['rest.iterations'];
      restIterations.push({
        key: `step${restIterations.length}`,
        method: '',
        'url.template': '',
        'response.data.path': '',
        isPaginated: false,
        'iteration.type': '',
      });
    });
  };

  return (
    <Section
      title={
        <div>
          Endpoint #{endpointIndex + 1}: Source Template Info
          <code>vendor_endpoints[{endpointIndex}].source_template</code>
        </div>
      }
      titleAcessory={
        <Typography variant="body2">
          Each iteration is considered a step in the API chain and contains instructions for that
          step. A step can consist of instructions either for a specific API endpoint or for a Nexla
          lookup. Each step can reference information from the previous step as Nexla macros and
          iterate over each item in the previous step.
        </Typography>
      }
      gap="16px"
    >
      {iterations.map((iteration, index) => {
        return <SourceIteration key={index} endpointIndex={endpointIndex} index={index} />;
      })}
      <Stack alignItems="flex-start">
        <Button onClick={onAddIteration} startIcon={<AddRounded />}>
          Add Another Iteration to Endpoint #{endpointIndex + 1} Source Template
        </Button>
      </Stack>
    </Section>
  );
};
